// Normalize user-typed access codes to the canonical XXXX-XXXX-XXXX-XXXX
// shape (16 chars from a confusable-free alphabet, dashed every 4). Accepts
// dashed, spaced, or unbroken input; uppercases; strips whitespace and
// internal hyphens before re-inserting at positions 4/8/12. Codes that don't
// fit the 16-char shape (e.g. legacy TEST-AAAA-… seeds, operator-prefixed
// labels like STUART-…, or BETA-prefixed pilot codes) pass through after
// uppercasing only.
//
// Shared so that every place a code enters the app normalizes it identically —
// Landing before it validates/stores, and Shell before it compares a marketing
// handoff (#code=…) against the stored session. Without the shared rule, a
// correct returning user whose handoff code differs only in case would fail
// the equality check and get bounced to Landing (where a consumed code is then
// rejected) instead of resuming. See Shell's accessCode initializer.
export function normalizeAccessCode(raw: string): string {
  const trimmed = raw.trim().toUpperCase();
  if (!trimmed) return "";
  const condensed = trimmed.replace(/[\s-]+/g, "");
  if (condensed.length === 16 && /^[A-Z0-9]+$/.test(condensed)) {
    return [
      condensed.slice(0, 4),
      condensed.slice(4, 8),
      condensed.slice(8, 12),
      condensed.slice(12, 16),
    ].join("-");
  }
  return trimmed;
}
